/**
 * Korean (한국어) translations
 * Context: Hibachi catering service for home parties
 */
const ko = {
	nav: {
		home: '홈',
		california: '캘리포니아',
		texas: '텍사스',
		florida: '플로리다',
		menu: '메뉴',
		faq: '자주 묻는 질문',
		freeEstimate: '무료 견적',
		bookNow: '예약하기',
		myBooking: '내 예약',
	},
	seo: {
		homeDescription: '최고 평점의 홈 철판요리 체험. 캘리포니아, 텍사스, 플로리다에서 철판 그릴과 셰프를 집으로 모셔갑니다.',
	},
	hero: {
		title: 'FAMILY FRIENDS HIBACHI',
		tagline: '미국 No.1 홈 철판 요리',
		subtitle: '집에서 즐기는 정통 일본 철판 요리',
		description: '전문 셰프가 철판 요리의 즐거움을 여러분의 뒷마당으로 직접 가져다 드립니다.',
		bookNow: '지금 예약',
		freeEstimate: '무료 견적',
	},
	howItWorks: {
		title: '이용 방법',
		subtitle: '완벽한 철판 파티를 위한 간단한 단계',
		step1: { title: '온라인 예약', description: '날짜, 시간, 메뉴를 선택하세요' },
		step2: { title: '저희가 준비', description: '모든 재료와 장비를 준비합니다' },
		step3: { title: '쇼를 즐기세요', description: '셰프의 퍼포먼스와 맛있는 음식을 즐기세요' },
		step4: { title: '저희가 정리', description: '뒷정리는 저희가 합니다' },
	},
	menu: {
		title: '가격 및 서비스',
		subtitle: '신선한 재료, 정통 맛',
		proteins: '메인 요리',
		sides: '사이드 & 에피타이저',
		chicken: '치킨',
		steak: '안심 스테이크',
		shrimp: '새우',
		salmon: '연어',
		lobster: '랍스터 테일',
		tofu: '두부 (채식)',
		friedRice: '철판 볶음밥',
		noodles: '야키소바',
		vegetables: '구운 야채',
		salad: '생강 샐러드',
		soup: '미소 수프',
		edamame: '에다마메',
		includes: {
			salad: '신선한 샐러드',
			rice: '볶음밥',
			vegetables: '철판 야채',
			show: '게임 & 쇼',
		},
		protein: {
			title: '단백질 선택',
			included: '포함',
		},
		upgrades: {
			title: '프리미엄 업그레이드',
			filet: '안심 스테이크',
			lobster: '랍스터',
			ribeye: '프리미엄 립아이',
			shrimp: '점보 새우',
			salmon: '자연산 연어',
			scallops: '대형 가리비',
		},
		addons: {
			title: '추가 메뉴',
			gyoza: '교자 (12개)',
			edamame: '에다마메',
			noodles: '면',
			thirdProtein: '세 번째 단백질',
		},
		coupon: {
			title: '특별 쿠폰',
			subtitle: '일요일~금요일 파티 전용!',
			email: '이메일 보내기',
		},
		note: {
			outdoor: '야외에서만 조리합니다.',
			weather: '비가 와도 셰프가 조리할 수 있는 건조한 공간이 있다면 서비스를 제공합니다.',
		},
	},
	pricing: {
		title: '가격',
		subtitle: '숨겨진 비용 없는 투명한 가격',
		perPerson: '인당',
		minimum: '모든 파티 최소 금액',
		kids: '12세 이하 어린이',
		includes: '포함 내역',
		includesList: {
			chef: '전문 철판 셰프',
			ingredients: '모든 재료 및 용품',
			equipment: '철판 그릴 및 장비',
			setup: '설치 및 정리',
			show: '라이브 쿠킹 쇼',
		},
		basic: { title: '베이직 패키지', description: '소규모 모임에 적합' },
		premium: { title: '프리미엄 패키지', description: '완벽한 철판 경험' },
		deluxe: { title: '디럭스 패키지', description: '최고급 다이닝' },
	},
	calendar: {
		available: '예약 가능',
		limited: '잔여 소량',
		busy: '예약 많음',
		unavailable: '예약 불가',
		today: '오늘',
		prevMonth: '이전 달',
		nextMonth: '다음 달',
		weekdays: {
			sun: '일',
			mon: '월',
			tue: '화',
			wed: '수',
			thu: '목',
			fri: '금',
			sat: '토',
		},
		months: {
			january: '1월',
			february: '2월',
			march: '3월',
			april: '4월',
			may: '5월',
			june: '6월',
			july: '7월',
			august: '8월',
			september: '9월',
			october: '10월',
			november: '11월',
			december: '12월',
		},
	},
	slider: {
		chef: '전문 철판 요리사의 퍼포먼스',
		steak: '맛있는 철판 스테이크',
		shrimp: '신선한 철판 새우',
		setup: '프리미엄 철판 세팅',
		presentation: '아름다운 음식 프레젠테이션',
	},
	booking: {
		title: '예약하기',
		subtitle: '지역을 선택하여 시작하세요',
		selectRegion: '지역 선택',
		california: '캘리포니아',
		texas: '텍사스',
		florida: '플로리다',
		californiaTagline: '전문 철판 요리를 집 앞까지',
		texasTagline: '텍사스에 철판 요리의 최고를 전합니다',
		floridaTagline: '선샤인 스테이트의 철판 경험',
		servingAreas: '서비스 지역',
		bookIn: '예약하기',
		note: '* 결제 필요 없음. 예약 확인을 위해 연락드립니다.',
		quickBook: '빠른 예약:',
		summary: '예약 상세',
		addToCalendar: '캘린더에 추가',
	},
	calculator: {
		title: '가격 계산기',
		subtitle: '즉시 견적 받기',
		guests: '인원 수',
		adults: '성인',
		kids: '어린이 (10세 이하)',
		upgrades: '선택 업그레이드',
		summary: '가격 요약',
		subtotal: '소계',
		discount: '단체 할인',
		minimum: '최소 주문',
		total: '합계',
		gratuity: '권장 팁',
		grandTotal: '총 금액',
		bookNow: '이벤트 예약',
		note: '* 위치에 따라 교통비가 추가될 수 있습니다.',
		minimumNotice: '최소 10명 필요',
		thirdProtein: '세 번째 단백질',
		noodles: '면',
	},
	gallery: {
		title: '갤러리',
		subtitle: 'Family Friends Hibachi의 차별화된 경험',
		items: {
			chef: '전문 철판 셰프',
			chefDesc: '전문 철판 셰프의 퍼포먼스',
			grill: '철판 그릴 세팅',
			grillDesc: '프리미엄 철판 그릴 세팅',
			steak: '철판 스테이크',
			steakDesc: '맛있는 철판 스테이크',
			vegetables: '철판 야채',
			vegetablesDesc: '신선한 철판 야채',
			shrimp: '철판 새우',
			shrimpDesc: '신선한 철판 새우',
			food: '음식 프레젠테이션',
			foodDesc: '아름다운 음식 프레젠테이션',
		},
	},
	reviews: {
		title: '고객 후기',
		subtitle: 'Family Friends Hibachi 경험에 대한 고객들의 평가를 확인하세요',
		bookNow: '이벤트 예약',
		ctaTitle: '나만의 특별한 경험을 만들 준비가 되셨나요?',
		ctaText: '수백 명의 만족한 고객과 함께하세요',
		rating: '5.0 평균 평점',
		verified: '100+ 인증된 후기',
		topRated: '최고 평가 서비스',
	},
	instagram: {
		title: '우리의 여정',
		followUs: '인스타그램 팔로우',
	},
	referral: {
		title: '친구 추천하고 보상 받기',
		subtitle: '철판의 즐거움을 나누고 보상을 받으세요!',
		step1Title: '코드 공유하기',
		step1Desc: '친구와 가족에게 고유한 추천 코드를 공유하세요',
		step2Title: '친구가 예약',
		step2Desc: '친구가 첫 예약 시 $30 할인',
		step3Title: '보상 받기',
		step3Desc: '다음 이벤트에 사용할 $50 크레딧 적립',
		yourReward: '내 보상',
		friendDiscount: '친구 할인',
		getCode: '추천 코드 받기',
		emailPlaceholder: '이메일 입력',
		invalidEmail: '유효한 이메일을 입력하세요',
		getCodeBtn: '코드 받기',
		successTitle: '추천 코드가 준비되었습니다!',
		successDesc: '이메일에서 고유한 추천 코드와 안내를 확인하세요.',
		terms: '* 친구가 첫 예약을 완료하면 보상이 적용됩니다. 추천 횟수 제한 없음!',
	},
	newsletter: {
		title: '독점 혜택 받기',
		subtitle: '특별 혜택과 파티 팁을 위해 뉴스레터를 구독하세요!',
		placeholder: '이메일 주소 입력',
		subscribe: '구독',
		invalidEmail: '유효한 이메일 주소를 입력하세요',
		success: '구독해 주셔서 감사합니다! 받은 편지함에서 독점 혜택을 확인하세요.',
		error: '문제가 발생했습니다. 다시 시도해 주세요.',
		privacy: '개인정보를 존중합니다. 언제든 구독 취소 가능.',
		benefit1: '독점 할인',
		benefit2: '파티 기획 팁',
		benefit3: '새 메뉴 업데이트',
	},
	myBooking: {
		title: '내 예약 확인',
		subtitle: '예약 시 사용한 이메일 또는 전화번호를 입력하세요',
		emailPlaceholder: '이메일 주소 입력',
		phonePlaceholder: '전화번호 입력',
		search: '예약 검색',
		searching: '검색 중...',
		results: '검색 결과',
		noResults: '예약을 찾을 수 없습니다',
		error: '검색 실패, 다시 시도해 주세요',
		bookingId: '예약 번호',
		needHelp: '도움이 필요하신가요?',
		contactUs: '질문이 있으시면 언제든 연락주세요',
		pendingNote: '2시간 내에 연락드려 확인해 드립니다',
		confirmedNote: '기다리고 있겠습니다! 셰프가 30분 일찍 도착합니다',
	},
	faq: {
		title: '자주 묻는 질문',
		subtitle: '알아야 할 모든 것',
		q1: '어느 지역에서 서비스하나요?',
		a1: '현재 캘리포니아, 텍사스, 플로리다에서 서비스합니다. 정확한 위치 확인은 문의해 주세요.',
		q2: '몇 명까지 가능한가요?',
		a2: '최소 10명부터 최대 50명까지 가능합니다. 대규모 이벤트는 별도 문의해 주세요.',
		q3: '제가 준비할 것은 무엇인가요?',
		a3: '장소와 손님만 준비하시면 됩니다! 모든 장비, 재료, 식기류와 설치/정리는 저희가 합니다.',
		q4: '얼마나 미리 예약해야 하나요?',
		a4: '평일은 2주 전, 주말은 3-4주 전 예약을 권장합니다. 인기 날짜는 빨리 마감됩니다!',
		q5: '식이 제한을 수용할 수 있나요?',
		a5: '네! 채식 옵션을 제공하며 대부분의 식이 제한을 수용합니다. 예약 시 알려주세요.',
		q6: '취소 정책은 어떻게 되나요?',
		a6: '7일 이전 취소 시 전액 환불. 3-6일 전 50% 환불. 3일 미만 환불 불가.',
	},
	contact: {
		title: '문의하기',
		subtitle: '도움이 필요하시면 연락주세요',
		phone: '전화',
		email: '이메일',
		hours: '운영 시간',
		address: '서비스 지역',
	},
	footer: {
		description: '정통 철판 요리 경험을 집으로',
		quickLinks: '바로가기',
		contact: '연락처',
		followUs: '팔로우',
		copyright: '© 2024 Family Friends Hibachi. All rights reserved.',
		allRightsReserved: 'All rights reserved.',
		privacyPolicy: '개인정보 처리방침',
		termsOfService: '서비스 약관',
	},
	menuSelection: {
		title: '요리 유형 선택',
		subtitle: '모든 식사에는 밥, 철판 야채, 특제 소스가 포함됩니다',
		regular: {
			title: '레귤러',
			proteins: '1인당 2가지 단백질',
			service: '쇼 포함, 90분 서비스',
		},
		premium: {
			title: '프리미엄',
			proteins: '2가지 프리미엄 단백질: 안심, 랍스터, 가리비',
			service: '쇼 포함, 120분 서비스',
		},
		catering: {
			title: '대규모 행사',
			note: '50인 이상 뷔페 스타일',
			proteins: '1인당 2가지 단백질',
			service: '쇼 포함, 3-4시간 서비스',
		},
		intimate: {
			title: '소규모 파티',
			note: '5-7명',
			includes: '샐러드, 교자, 에다마메, 면 + 혼합 단백질',
			substitution: '동일 가격 단백질 교체 가능',
		},
	},
	form: {
		name: '성명',
		namePlaceholder: '이름을 입력하세요',
		email: '이메일',
		emailPlaceholder: '이메일 입력',
		phone: '전화번호',
		phonePlaceholder: '전화번호 입력',
		date: '행사 날짜',
		time: '선호 시간',
		guests: '인원 수',
		guestsHint: '최소 10명',
		region: '지역 선택',
		eventType: '행사 유형',
		message: '추가 메시지',
		messagePlaceholder: '행사에 대해 알려주세요...',
		selectOption: '선택하세요',
		selectDate: '날짜 선택',
		submit: '제출',
		submitting: '제출 중...',
		submitReservation: '예약 제출',
		success: '예약 완료!',
		successMessage: '2시간 내에 연락드려 상세 사항을 확인해 드립니다.',
		weWillContact: '곧 연락드려 상세 사항을 확인합니다.',
		error: '문제가 발생했습니다. 다시 시도하거나 전화주세요.',
		required: '필수',
		people: '명',
		noPaymentRequired: '* 지금 결제 필요 없음. 확인을 위해 연락드립니다.',
		invalidEmail: '올바른 이메일 주소를 입력하세요',
		invalidPhone: '올바른 전화번호를 입력하세요',
		eventTypes: {
			birthday: '생일 파티',
			anniversary: '기념일',
			graduation: '졸업',
			corporate: '기업 행사',
			holiday: '명절 파티',
			other: '기타',
		},
		referralSource: '저희를 어떻게 알게 되셨나요?',
		referral: {
			google: 'Google 검색',
			friend: '친구 추천',
			event: '이벤트에서 봤습니다',
			other: '기타',
		},
		couponCode: '쿠폰 코드',
		couponPlaceholder: '쿠폰 코드 입력 (선택사항)',
		applyCoupon: '적용',
	},
	estimate: {
		title: '무료 견적 받기',
		subtitle: '행사에 대해 알려주시면 맞춤 견적을 드립니다',
		benefits: {
			title: '왜 저희를 선택할까요?',
			professional: '전문 교육받은 셰프',
			fresh: '신선한 고급 재료',
			entertainment: '라이브 쿠킹 쇼',
			cleanup: '완벽한 설치 및 정리',
			custom: '맞춤 메뉴 옵션',
		},
	},
	bookNow: {
		title: '철판 파티 예약',
		subtitle: '아래 양식을 작성하여 날짜를 예약하세요',
		selectRegion: '먼저 지역을 선택하세요',
		formTitle: '행사 상세',
		pricing: '1인당 $45부터',
		note: '2시간 내에 가능 여부를 확인해 드립니다',
	},
	notFound: {
		title: '페이지를 찾을 수 없습니다',
		description: '찾으시는 페이지가 존재하지 않습니다.',
		backHome: '홈으로 돌아가기',
	},
	common: {
		learnMore: '자세히 보기',
		viewAll: '전체 보기',
		loading: '로딩 중...',
		close: '닫기',
		backToHome: '홈으로',
		total: '합계',
		toBeConfirmed: '확인 예정',
		specialOffer: '특별 혜택',
		goTo: '이동',
		previous: '이전',
		next: '다음',
	},
	topBar: {
		textUs: '문자 보내기',
		email: '이메일',
	},
	photoShare: {
		title: '사진 공유하기',
		subtitle: '히바치 경험을 공유하고 다음 이벤트에서 $25 할인받으세요!',
		option1Title: '인스타그램에 게시',
		option1Desc: '@familyfriendshibachi 태그와 #FamilyFriendsHibachi 사용',
		option2Title: '직접 업로드',
		option2Desc: '사진을 공유해 주세요',
		dropzone: '사진을 여기에 끌어다 놓거나 클릭하여 찾아보기',
		maxFiles: '최대 5장',
		instagramPlaceholder: '인스타그램 아이디 (선택사항)',
		submit: '사진 제출',
		submitting: '업로드 중...',
		successTitle: '사진이 제출되었습니다!',
		successDesc: '공유해 주셔서 감사합니다! $25 크레딧이 다음 예약에 적용됩니다.',
		terms: '* 사진 검토 후 크레딧이 적용됩니다. 사진이 저희 소셜 미디어에 게시될 수 있습니다.',
	},
	offer: {
		noTravel: '교통비 무료',
		within50: '50마일 이내',
		noHidden: '숨겨진 비용 없음',
		exclusive: '독점 할인',
		freeSetup: '무료 테이블 및 의자',
		sunFri: '일요일~금요일 특가!',
	},
	coupon: {
		minGuests: '최소 {{count}}명 필요',
		applied: '쿠폰 적용! 할인: {{discount}}',
		invalid: '유효하지 않은 쿠폰 코드',
		checkFailed: '확인 실패',
		under15: '15명 미만',
		range15to25: '15-25명',
		range25to35: '25-35명',
		over35: '35명 이상',
	},
	privacy: {
		title: '개인정보 처리방침',
		lastUpdated: '최종 업데이트: 2026년 1월',
		section1: {
			title: '1. 수집하는 정보',
			intro: 'Family Friends Hibachi 서비스 이용 시 다음 정보를 수집할 수 있습니다:',
			contact: '연락처 정보',
			contactDesc: '이름, 이메일 주소, 전화번호',
			booking: '예약 상세',
			bookingDesc: '이벤트 날짜, 시간, 장소, 인원수',
			payment: '결제 정보',
			paymentDesc: '제3자 결제 서비스를 통해 안전하게 처리',
			usage: '사용 데이터',
			usageDesc: '웹사이트 이용 방식',
		},
		section2: {
			title: '2. 정보 사용 방법',
			item1: '예약 처리 및 확인',
			item2: '예약 확인 및 알림 발송',
			item3: '문의 응답',
			item4: '서비스 개선',
			item5: '프로모션 발송 (동의 시)',
		},
		section3: {
			title: '3. 정보 공유',
			intro: '개인정보를 판매하지 않습니다. 다음과 정보를 공유할 수 있습니다:',
			item1: '운영을 지원하는 서비스 제공업체',
			item2: '법적 요구 시 관계 당국',
		},
		section4: {
			title: '4. 데이터 보안',
			desc: '개인정보 보호를 위해 적절한 보안 조치를 시행합니다. 그러나 인터넷 전송은 100% 안전하지 않습니다.',
		},
		section5: {
			title: '5. 귀하의 권리',
			intro: '다음과 같은 권리가 있습니다:',
			item1: '개인 데이터 접근',
			item2: '부정확한 데이터 수정 요청',
			item3: '데이터 삭제 요청',
			item4: '마케팅 수신 거부',
		},
		section6: {
			title: '6. 쿠키',
			desc: '브라우징 경험 개선 및 사이트 트래픽 분석을 위해 쿠키를 사용합니다. 브라우저 설정을 통해 쿠키를 제어할 수 있습니다.',
		},
		section7: {
			title: '7. 문의',
			intro: '개인정보 관련 문의:',
		},
	},
	terms: {
		title: '서비스 약관',
		lastUpdated: '최종 업데이트: 2026년 1월',
		section1: {
			title: '1. 서비스',
			desc: 'Family Friends Hibachi는 모바일 히바치 케이터링 서비스를 제공합니다. 전문 셰프와 장비를 고객 장소로 가져가 정통 히바치 요리를 준비합니다.',
		},
		section2: {
			title: '2. 예약',
			minimum: '최소 인원',
			minimumDesc: '최소 10명 필요',
			confirmation: '확인',
			confirmationDesc: '팀이 연락 후 예약 확정',
			deposit: '보증금',
			depositDesc: '날짜 확보를 위해 보증금이 필요할 수 있음',
			finalCount: '최종 인원',
			finalCountDesc: '이벤트 48시간 전에 인원 확정 필요',
		},
		section3: {
			title: '3. 취소 정책',
			sevenDays: '7일 이상 전',
			sevenDaysDesc: '보증금 전액 환불',
			threeSixDays: '3-6일 전',
			threeSixDaysDesc: '보증금 50% 환불',
			lessThanThree: '3일 미만',
			lessThanThreeDesc: '보증금 환불 불가',
			weather: '날씨',
			weatherDesc: '악천후 시 무료 일정 변경',
		},
		section4: {
			title: '4. 고객 책임',
			intro: '고객이 제공해야 할 사항:',
			item1: '충분한 야외 조리 공간 (최소 10x10피트)',
			item2: '전기 접근 (50피트 이내 표준 콘센트)',
			item3: '손님용 테이블과 의자',
			item4: '필요시 날씨 보호 (텐트, 가제보 등)',
		},
		section5: {
			title: '5. 식품 안전 및 알레르기',
			desc: '예약 시 식품 알레르기나 식이 제한 사항을 알려주세요. 주의를 기울이지만, 히바치 조리 특성상 완전한 무알레르겐 환경을 보장할 수 없습니다.',
		},
		section6: {
			title: '6. 책임',
			desc: 'Family Friends Hibachi는 책임 보험에 가입되어 있습니다. 그러나 고객은 손님과 재산에 대한 책임이 있습니다. 손님 행동이나 기존 재산 상태로 인한 사고에 대해 당사는 책임지지 않습니다.',
		},
		section7: {
			title: '7. 서비스 지역',
			intro: '현재 서비스 지역:',
			california: '캘리포니아 (로스앤젤레스, 샌디에이고, 샌프란시스코 및 주변 지역)',
			texas: '텍사스 (휴스턴, 달라스, 오스틴, 샌안토니오 및 주변 지역)',
			florida: '플로리다 (마이애미, 포트로더데일 및 주변 지역)',
			travelFee: '표준 서비스 지역 외 장소에는 교통비가 부과될 수 있습니다.',
		},
		section8: {
			title: '8. 약관 변경',
			desc: '언제든지 이 약관을 수정할 권리를 보유합니다. 서비스 계속 이용 시 업데이트된 약관에 동의한 것으로 간주됩니다.',
		},
		section9: {
			title: '9. 연락처',
			intro: '약관 관련 문의:',
		},
	},
	status: {
		pending: '대기 중',
		confirmed: '확정',
		completed: '완료',
		cancelled: '취소',
	},
	timeSlot: {
		afternoon: '오후',
		evening: '저녁',
		night: '밤',
	},
	admin: {
		login: {
			title: '관리자 로그인',
			subtitle: '비밀번호를 입력하세요',
			password: '비밀번호',
			loginButton: '로그인',
			loggingIn: '로그인 중...',
			invalidPassword: '비밀번호가 틀립니다',
			loginFailed: '로그인 실패',
			contactHelp: '도움 문의',
		},
		dashboard: {
			title: '관리자 대시보드',
			logout: '로그아웃',
		},
		stats: {
			totalBookings: '전체',
			pending: '대기 중',
			confirmed: '확정',
			completed: '완료',
			cancelled: '취소',
			totalGuests: '총 인원',
		},
		tabs: {
			all: '전체',
			pending: '대기 중',
			confirmed: '확정',
			completed: '완료',
			cancelled: '취소',
		},
		booking: {
			noBookings: '예약 없음',
			noBookingsHint: '예약이 여기에 표시됩니다',
			guests: '명',
			booking: '예약',
			estimate: '견적',
			contactInfo: '연락처 정보',
			eventDetails: '행사 상세',
			date: '날짜',
			time: '시간',
			notSpecified: '미지정',
			region: '지역',
			additionalNotes: '추가 메모',
			updateStatus: '상태 업데이트',
			emailCustomer: '이메일 보내기',
			callCustomer: '전화하기',
		},
	},
};

export default ko;

